export const EventType = {
	// internal
	dialog:
	{
		onDialogInited: 'IM:Dialog:onDialogInited',
		onMessageDeleted: 'IM:Dialog:onMessageDeleted',
		onMessageIsVisible: 'IM:Dialog:onMessageIsVisible',
		onMessageIsNotVisible: 'IM:Dialog:onMessageIsNotVisible',
		onClickMessageContextMenu: 'IM:Dialog:onClickMessageContextMenu',
		onCloseChat: 'IM:Dialog:onCloseChat',

		scrollToBottom: 'IM:Dialog:scrollToBottom',
		pinQuestion: 'IM:Dialog:pinQuestion',
		goToMessageContext: 'IM:Dialog:goToMessageContext',
		showForwardPopup: 'IM:Dialog:showForwardPopup',
		openComments: 'IM:Dialog:openComments',
		closeComments: 'IM:Dialog:closeComments',
		showLoadingBar: 'IM:Dialog:showLoadingBar',
		hideLoadingBar: 'IM:Dialog:hideLoadingBar',
		showQuoteButton: 'IM:Dialog:showQuoteButton',
		openBulkActionsMode: 'IM:Dialog:openBulkActionsMode',
		closeBulkActionsMode: 'IM:Dialog:closeBulkActionsMode',
	},
	textarea:
	{
		onBeforeSendMessage: 'IM:Textarea:onBeforeSendMessage',
		onAfterSendMessage: 'IM:Textarea:onAfterSendMessage',

		editMessage: 'IM:Textarea:editMessage',
		replyMessage: 'IM:Textarea:replyMessage',
		insertText: 'IM:Textarea:insertText',
		insertMention: 'IM:Textarea:insertMention',
		selectSlashCommand: 'IM:Textarea:selectSlashCommand',
		closeSlashCommandPopup: 'IM:Textarea:closeSlashCommandPopup',
		insertForward: 'IM:Textarea:insertForward',
		sendMessage: 'IM:Textarea:sendMessage',
		openUploadPreview: 'IM:Textarea:openUploadPreview',
		getText: 'IM:Textarea:getText',
		closePanel: 'IM:Textarea:closePanel',
	},
	sidebar:
	{
		open: 'IM:Sidebar:open',
		close: 'IM:Sidebar:close',
	},
	header:
	{
		openAddToChatPopup: 'IM:Header:openAddToChatPopup',
	},
	search:
	{
		keyPressed: 'IM:Search:keyPressed',
	},
	recent:
	{
		openSearch: 'IM.Recent:openSearch',
		openNestedList: 'IM.Recent:openNestedList',
		closeNestedList: 'IM.Recent:closeNestedList',
	},
	mention:
	{
		selectItem: 'IM:Mention:selectItem',
		onAddUserToChat: 'IM:Mention:onAddUserToChat',
		onNestedMenuClosed: 'IM:Mention:onNestedMenuClosed',
	},
	reaction:
	{
		onReactionSelected: 'IM:Reaction:onReactionSelected',
	},
	request:
	{
		onAuthError: 'IM:request:onAuthError',
	},
	audioPlayer:
	{
		pause: 'IM:AudioPlayer:pause',
	},
	roundVideoPlayer:
	{
		onClickPlay: 'IM:RoundVideoPlayer:onClickPlay',
	},
	player:
	{
		playNext: 'IM:Player:playNext',
		rateChange: 'IM:Player:rateChange',
	},
	key:
	{
		onBeforeEscape: 'IM:Keys:onBeforeEscape',
	},
	notifier:
	{
		onBeforeShowMessage: 'IM:Notifier:onBeforeShowMessage',
	},
	notification:
	{
		onFilterAuthorPopupStateChange: 'IM:Notification:Filter:onAuthorPopupStateChange',
		onFilterAuthorTagAdd: 'IM:Notification:Filter:onAuthorTagAdd',
		onFilterAuthorTagRemove: 'IM:Notification:Filter:onAuthorTagRemove',
	},

	// external
	messenger:
	{
		onReady: 'IM:Messenger:onReady', // MessengerRoot is mounted
		onClose: 'IM:Messenger:onClose', // the surface is gone: unmount or slider close
	},
	layout:
	{
		onLayoutChange: 'IM.Layout:onLayoutChange',
		onOpenNotifications: 'IM.Layout:onOpenNotifications',
	},
	slider:
	{
		onClose: 'onChatSliderClose',
	},
	counter:
	{
		onNotificationCounterChange: 'onImUpdateCounterNotify',
		onChatCounterChange: 'onImUpdateCounterMessage',
		onImUpdateCounter: 'onImUpdateCounter',
		onUpdate: 'IM.Counters:onUpdate',
	},
	task:
	{
		onMembersCountChange: 'tasks:card:onMembersCountChange',
		openCardFromMessage: 'tasks:chat-action:before-execute',
	},
	collab:
	{
		onFirstOpen: 'IM:Collab:onFirstOpen',
	},
	call:
	{
		onFold: 'CallController::onFold',
		onJoinFromRecentItem: 'IM.Call:onJoinFromRecentItem',
	},
	lines:
	{
		onInit: 'onLinesInit',
		openChat: 'openLinesChat',
		onChatOpen: 'onLinesChatOpen',
	},
	desktop:
	{
		onInit: 'onDesktopInit',
		onReload: 'onDesktopReload',
		onSyncPause: 'onDesktopSyncPause',
		onUserAway: 'BXUserAway',
		onWakeUp: 'BXWakeAction',
		onBxLink: 'BXProtocolUrl',
		onExit: 'BXExitApplication',
		onIconClick: 'BXApplicationClick',
		onNewTabClick: 'BXNewTabClick',
	},
	sending:
	{
		onBeforeAddMessageToModel: 'IM:Textarea:onBeforeAddMessageToModel',
	},
	guest:
	{
		onAfterGuestNamePopupClose: 'IM:Guest:onAfterGuestNamePopupClose',
		/**
		 * Emitted when an already identified guest (the guest-name popup will NOT be shown)
		 * opens a chat. On the first visit — when the popup will be shown — this event is
		 * NOT emitted: identification is signalled by the popup via `onAfterGuestNamePopupClose`.
		 * Payload: { dialogId: string }.
		 */
		onInitialChatOpen: 'IM:Guest:onInitialChatOpen',
	},
};
